// Public support page — registered as the App Store Connect support URL
// (#336) and linked from the Field app's Profile screen. Also serves as the
// report path for user-generated content (#337).
import LegalPage from './LegalPage'

export default function Support() {
  return (
    <LegalPage eyebrow="Help" title="Support">
      <p>
        GroundOps support is handled by email. We aim to respond within two business days
        (AEST/AEDT).
      </p>
      <div className="legal-callout">
        <p>
          <a href="mailto:support@groundops.app">support@groundops.app</a>
        </p>
      </div>

      <h2>Getting help</h2>
      <p>To help us resolve things quickly, include:</p>
      <ul>
        <li>the email address or phone number on your GroundOps account,</li>
        <li>your organisation's name,</li>
        <li>the job reference (e.g. <code>JOB-1A2B3C4D</code>) if it concerns a specific job,</li>
        <li>what you expected to happen and what happened instead.</li>
      </ul>

      <h2>Signing in</h2>
      <p>
        GroundOps is invite-only. If you can't sign in to the Field app, check that the phone
        number you entered is the one your administrator invited — codes are only sent to
        registered numbers. If you've changed numbers, ask your organisation's administrator to
        update your account, or contact support.
      </p>

      <h2>Reporting a problem with photos or messages</h2>
      <p>
        GroundOps workspaces are private to your organisation, and content is limited to invited
        members. If you see a photo or message that is offensive, inaccurate, or shouldn't be
        there, report it to your organisation's administrator — administrators can remove members
        and manage content — or email support with the job reference and a description. We treat
        reports of offensive content as a priority.
      </p>

      <h2>Account deletion</h2>
      <p>
        You can request deletion of your account at{' '}
        <a href="https://app.groundops.app/delete-account">
          app.groundops.app/delete-account
        </a>{' '}
        — no app install needed. We text a code to the mobile number on your account to check it
        is you, then show you what deleting would remove.
      </p>
      <p>
        You can also open <em>Profile → Request account deletion</em> in the GroundOps Field app,
        or email <a href="mailto:support@groundops.app">support@groundops.app</a> from the address
        on your account.
      </p>
      <p>
        If your account belongs to an organisation someone else runs, an administrator confirms the
        request before your personal details are removed. Work records stay with that organisation
        for its compliance obligations — see the <a href="/privacy">Privacy Policy</a> for what may
        be retained.
      </p>
    </LegalPage>
  )
}
